/**
* Created by vouill on 8/18/18.
*/

<template>
  <div class="v-container">
    Se rencontrer
  </div>
</template>

<style scoped>
.v-container {
  font-weight: bold;
  font-size: 22px;
  color: #ef6c00;
  border-bottom: 4px solid #ef6c00;
  margin-bottom: 1em;
  padding-bottom: 0.5em;
}
</style>

<script>
export default {
  name: "EventTitle",
  props: {},
  components: {},
  data() {
    return {};
  }
};
</script>
